import * as _ from 'lodash';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '..';
import { IBaseResponse, IListItem, IXmTracking, IXmTrackingCenterCounts, IXmTrackingCounts } from '@nkr/models/index';
import { XmResult } from '@nkr/enums/xm-result';

export enum XmListType {
    Unknown = 0,
    RequestedFrom = 10,
    RequestedBy = 20,
    History = 30,
    All = 35,
    MissingFxm = 37,
    AdminPendingShipping = 40,
    AdminShippedPendingDCenter = 50,
    AdminShippedPendingRCenter = 60,
    AdminCompleted = 70,
    AdminCancelled = 80
}

export interface IXmTrackingResponse {
    data: {
        success: boolean,
        message: string,
        results: IXmTracking
    }
}


export interface IXmTrackingListResponse {
    data: {
        success: boolean,
        message: string,
        results: IXmTracking[]
    }
}

export interface IXmTrackingCountResponse {
    data: {
        success: boolean,
        message: string,
        results: IXmTrackingCounts
    }
}

export interface IXmTrackingCenterCountResponse {
    data: {
        success: boolean,
        message: string,
        results: IXmTrackingCenterCounts
    }
}

export interface IXmTrackingLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            resultList: IListItem[],
            statusList: IListItem[],
            xmTypeList: IListItem[],
            cancelReasons: IListItem[]
        }
    }
}

export const ActionCreators = {
    getById: (xmTrackingId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/get?xmTrackingId=${xmTrackingId}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    getByCenter: (centerId: number, listType: XmListType) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingListResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/by-center?centerId=${centerId}&listType=${listType}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IXmTrackingListResponse) => {
            return Promise.resolve(response);
        });
    },
    getCounts: () => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingCountResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/counts`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IXmTrackingCountResponse) => {
            return Promise.resolve(response);
        });
    },
    getCountsByCenter: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingCenterCountResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/counts/${centerId}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IXmTrackingCenterCountResponse) => {
            return Promise.resolve(response);
        });
    },
    getLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingLookupDataResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/lookup-data`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IXmTrackingLookupDataResponse) => {
            return Promise.resolve(response);
        });
    },
    cancelRequest: (id: number, cancelReason: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/cancel-request/${cancelReason}`
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    markReceived: (id: number, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/mark-received?centerId=${centerId}`
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    markReceivedBack: (id: number, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/mark-received-back?centerId=${centerId}`
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    markShippedOut: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/mark-shipped-out?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    markRemoteShipped: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/mark-remote-shipped?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    markShippedBack: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/mark-shipped-back?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    requestUpdate: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/request-update`
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    recordResults: (id: number, rootCause: string, correctiveAction: string, result: XmResult, isDcComplete: boolean, initials: string, cellPronase: boolean, cellCount: string, cellViability: string, centerId: number, file: File) => (dispatch: Dispatch<IApplicationState>): Promise<IXmTrackingResponse> => {
        var formData = new FormData();
        formData.append('rootCause', rootCause);
        formData.append('correctiveAction', correctiveAction);
        formData.append('result', result.toString());
        formData.append('isDcComplete', isDcComplete.toString());
        formData.append('initials', initials);
        formData.append('cellPronase', cellPronase.toString());
        formData.append('cellCount', cellCount);
        formData.append('cellViability', cellViability);
        formData.append('file', file);

        let options = {
            url: `${__API__}/xm-tracking/${id}/record-results?centerId=${centerId}`,
            data: formData
        };

        return dispatch(AuthActionCreators.apiPostFormData(options)).then((response: IXmTrackingResponse) => {
            return Promise.resolve(response);
        });
    },
    updateDeadline: (id: number, deadline: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/xm-tracking/${id}/deadline?deadline=${deadline}`
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    }

};
